import { create } from 'zustand';
import {
  initialPurchaseRequestForm,
  PurchaseRequest,
  PurchaseRequestForm,
  PurchaseRequestRecord,
  RequestLineForm,
} from '../types/PurchaseRequest';
import { v4 as uuidv4 } from 'uuid';

type PurchaseRequestState = {
  data: PurchaseRequest | null;
  setData: (data: PurchaseRequest | null) => void;
  formData: PurchaseRequestForm;
  setFormData: (
    data: PurchaseRequestForm | PurchaseRequestRecord | undefined,
  ) => void;
  requestLine: RequestLineForm | null;
  setRequestLine: (data: RequestLineForm) => void;
  addRequestLine: (data: RequestLineForm) => void;
  editRequestLine: (id: string, newData: RequestLineForm) => void;
  removeRequestLine: (id: string) => void;
  resetForm: () => void;
};

export const usePurchaseRequestStore = create<PurchaseRequestState>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  formData: initialPurchaseRequestForm,
  setFormData: (formData) => set({ formData }),
  requestLine: null,
  setRequestLine: (requestLine) => set({ requestLine }),
  addRequestLine: (data: RequestLineForm) => {
    const newData = { ...data, uuid: uuidv4() };
    set((state) => ({
      formData: {
        ...state.formData,
        requestLines: [...state.formData.requestLines, newData],
      },
    }));
  },
  editRequestLine: (uuid, newData) => {
    // Implementation of editOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        requestLines: state.formData.requestLines.map((line) =>
          line.uuid === uuid ? { ...line, ...newData } : line,
        ),
      },
    }));
  },
  removeRequestLine: (uuid) => {
    // Implementation of removeOrderLine function
    set((state) => ({
      formData: {
        ...state.formData,
        requestLines: state.formData.requestLines?.filter(
          (line) => line.uuid !== uuid,
        ),
      },
    }));
  },
  resetForm: () => set({ formData: initialPurchaseRequestForm }),
}));

type PurchaseRequestDetailState = {
  data: React.Key[];
  setData: (data: React.Key[]) => void;
  resetSelectedRowKeys: () => void;
};

export const usePurchaseRequestDetailStore = create<PurchaseRequestDetailState>(
  (set) => ({
    data: [],
    setData: (data) => set({ data }),
    resetSelectedRowKeys: () => set({ data: [] }),
  }),
);
